import { call, put, select } from "redux-saga/effects";
import { notify } from "../../../services/notification";
import api, { makeOptions, queryBuilder } from "../../../services/api";
import NotaFullSearch from "../../ducks/notafull/search";

const getAuthData = (state) => state.auth.data;

export function* fetch(action) {
  try {
    const { params } = action;
    const query = params ? queryBuilder(params) : "";
    const url = `notafull?${query}`;
    const authData = yield select(getAuthData);
    const { data } = yield call(api.get, url, makeOptions(authData));

    yield put(NotaFullSearch.success(data));
    
  } catch (err) {
    notify("error", err.response.data.error.message);
    yield put(
      NotaFullSearch.failure(err.response.data.error.message)
    );
  }
}
